import React, {useContext} from 'react';
import PropTypes from 'prop-types';

import Badge from "components/Badge";
import RightDrawer from "components/WMS/Mobile/RightDrawer";
import RightDrawerDesktop from "components/WMS/Desktop/RightDrawerDesktop";

import ProductProblemDrawer from "../ProductProblemDrawer";
import ShipmentInfosHeader from "./components/ShipmentInfosHeader";
import CarrierIcon from "./components/CarrierIcon";

import {WMSContext} from "../../../../../../context/WMSContext";
import {PackingContext} from "../../../PackingContext";


SelectedItemPackingDrawer.propTypes = {
    open: PropTypes.bool.isRequired,
    handleClose: PropTypes.func.isRequired,
    packingStep: PropTypes.object.isRequired
};

function SelectedItemPackingDrawer({open, handleClose, packingStep, ...props}) {
    const {isMobile} = useContext(WMSContext)
    const {openProductProblemDrawer, setOpenProductProblemDrawer} = useContext(PackingContext);

    const drawerContent = (
        <>
            {props.children}
            {openProductProblemDrawer.isOpen && (
                <ProductProblemDrawer
                    open={openProductProblemDrawer.isOpen}
                    handleClose={() => setOpenProductProblemDrawer({
                        ...openProductProblemDrawer,
                        isOpen: false
                    })}
                    product={openProductProblemDrawer.product}
                    handleProductCancelled={openProductProblemDrawer.handleProductCancelled}
                />
            )}
        </>
    )

    if (isMobile) {
        return (
            <RightDrawer
                open={open}
                handleClose={handleClose}
                headerLeftContent={<ShipmentInfosHeader selectedShipment={packingStep.selectedShipment} />}
                headerRightContent={<CarrierIcon shippingMethod={packingStep.selectedShipment.shippingMethod} />}
            >
                {drawerContent}
            </RightDrawer>
        )
    } else {
        return (
            <RightDrawerDesktop
                open={open}
                onClose={handleClose}
                withoutHeadBorder={true}
                title={<ShipmentInfosHeader selectedShipment={packingStep.selectedShipment} />}
                subtitle={(
                    <Badge
                        size={'large'}
                        rounded
                        color={'info'}
                        isBold={false}
                    >
                        <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px'
                        }}>
                            <CarrierIcon shippingMethod={packingStep.selectedShipment.shippingMethod} />
                            {packingStep.selectedShipment.shippingMethod.name}
                        </div>
                    </Badge>
                )}
            >
                {drawerContent}
            </RightDrawerDesktop>
        );
    }
}

export default SelectedItemPackingDrawer;
